module.exports = __webpack_public_path__ + "img/62.088d0546.png";